






































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ThDropdownVue from "../components/ThDropdown.vue";
import AllUserTreeVue, { UserTree } from "@/components/User/AllUserTree.vue";
import { DatePickerOptions } from "element-ui/types/date-picker";
import version from "@/version";

@Component({
    components: {
        "th-dropdown": ThDropdownVue,
        "user-tree": AllUserTreeVue,
    }
})
export default class ImportLogs extends Vue {
    searchKey: string = "";
    typeList: DataTable.DropItem[] = [
        { text: "全部", id: "" },
        { text: "期初", id: 1 },
        { text: "凭证", id: 2 },
        { text: "固定资产", id: 3 },
        { text: "增值税票", id: 4 },
        { text: "日记账", id: 5 },
        { text: "工资表", id: 6 },
        { text: "工商信息", id: 7 },
        { text: "收费数据", id: 8 },
        { text: "合作商", id: 9 },
    ];
    typeStatus: DataTable.DropItem = this.typeList[0];
    allType: string = "";
    currentPage: number = 1;
    totalElements: number = 0;
    size: number = 15;
    dateRange: Date[] = [new Date(), new Date()];
    startDay: string = this.$utils.simpleDateFormat(new Date(), "d");
    endDay: string = this.$utils.simpleDateFormat(new Date(), "d");
    tableDate: ImportLog[] = []
    pickerOptions: DatePickerOptions = {
        shortcuts: [{
            text: "最近一周",
            onClick(picker: any) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
            }
        }, {
            text: "最近一个月",
            onClick(picker: any) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
            }
        }, {
            text: "最近三个月",
            onClick(picker: any) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
            }
        }]
    }
    mounted() {
        this.fetchData()
    }
    // 搜索
    startSearch() {
        this.currentPage = 1
        this.fetchData();
    }
    //选择时间
    changeDate(date: Date[]) {
        this.startDay = this.$utils.simpleDateFormat(date[0], "d");
        this.endDay = this.$utils.simpleDateFormat(date[1], "d");
        this.fetchData();
    }
    // 获取表格数据
    fetchData() {
        Vue.axios
            .get(
                `file/history?page=${this.currentPage - 1}&size=${this.size}&startDay=${this.startDay}&endDay=${this.endDay}&type=${this.typeStatus.id}&searchKey=${this.searchKey}`,
            )
            .then(res => {
                this.tableDate = res.data.content
                for (let i = 0; i < this.tableDate.length; i++) {
                    this.tableDate[i].gmtCreate = this.getTime(new Date(this.tableDate[i].gmtCreate))
                    this.totalElements = res.data.totalElements;
                }
            });
    }
    // 分页
    handleCurrentChange(val: number) {
        this.currentPage = val;
        this.fetchData();
    }
    // 转化时间
    getTime(date: any) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? ("0" + m) : m;
        let d = date.getDate();
        d = d < 10 ? ("0" + d) : d;
        let h = date.getHours();
        let minute = date.getMinutes();
        minute = minute < 10 ? ("0" + minute) : minute;
        return y + "-" + m + "-" + d + " " + h + ":" + minute;
    }

    excelLink = "";
    showExcel = false;
    // 获取excal下载地址
    async readExcal(oss: string) {
        let res = await Vue.axios.get(`file/history/url?ossObjectKey=${oss}`);
        this.excelLink = "https://view.officeapps.live.com/op/view.aspx?src=" + res.data;
        this.showExcel = true;
    }
}
